//#region Imports
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { AccordionModule } from 'primeng/accordion';
import { TreeTableModule } from 'primeng/treetable';
import { CheckboxModule } from 'primeng/checkbox';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CardModule } from 'primeng/card';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { StepsModule } from 'primeng/steps';
import { PasswordModule } from 'primeng/password';
import { DividerModule } from 'primeng/divider';
import { SidebarModule } from 'primeng/sidebar';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MenuModule } from 'primeng/menu';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { TabViewModule } from 'primeng/tabview';
import { SelectButtonModule } from 'primeng/selectbutton';
import { CalendarModule } from 'primeng/calendar';
import { GalleriaModule } from 'primeng/galleria';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { BadgeModule } from 'primeng/badge';
import { TagModule } from 'primeng/tag';
import { InputNumberModule } from 'primeng/inputnumber';
import { ChartModule } from 'primeng/chart';
import { ProgressBarModule } from 'primeng/progressbar';
import { ChipModule } from 'primeng/chip';
import { RadioButtonModule } from 'primeng/radiobutton';
import { MessagesModule } from 'primeng/messages';
import { TimelineModule } from 'primeng/timeline';
import { FileUploadModule } from 'primeng/fileupload';
import { InplaceModule } from 'primeng/inplace';
import { MessageModule } from 'primeng/message';
import { SliderModule } from 'primeng/slider';
import { SplitButtonModule } from 'primeng/splitbutton';
import { PanelModule } from 'primeng/panel';
import {PaginatorModule} from 'primeng/paginator';
import {MenubarModule} from 'primeng/menubar';
import { KeyFilterModule } from 'primeng/keyfilter';
import { EditorModule } from 'primeng/editor';
import { ToastModule } from 'primeng/toast';
import { AutoFocusModule } from 'primeng/autofocus';
import { InputOtpModule } from 'primeng/inputotp';
import { ChipsModule } from 'primeng/chips';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { SpeedDialModule } from 'primeng/speeddial';
import { ImageModule } from 'primeng/image';
import { SkeletonModule } from 'primeng/skeleton';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { FloatLabelModule } from 'primeng/floatlabel';
import { DragDropModule } from 'primeng/dragdrop';

//#endregion Imports

export const PrimeNgModules: any[] = [
  SkeletonModule,
  SpeedDialModule,
  InputGroupModule,
  InputGroupAddonModule,
  AutoFocusModule,
  EditorModule,
  MenubarModule,
  MessageModule,
  TimelineModule,
  RadioButtonModule,
  ChipModule,
  ChartModule,
  BadgeModule,
  AvatarModule,
  AvatarGroupModule,
  TableModule,
  InputTextModule,
  DropdownModule,
  ButtonModule,
  DialogModule,
  MultiSelectModule,
  AccordionModule,
  TreeTableModule,
  CheckboxModule,
  TooltipModule,
  ConfirmDialogModule,
  ToggleButtonModule,
  AutoCompleteModule,
  CardModule,
  ScrollPanelModule,
  ProgressSpinnerModule,
  StepsModule,
  PasswordModule,
  DividerModule,
  SidebarModule,
  InputSwitchModule,
  MenuModule,
  InputTextareaModule,
  TabViewModule,
  SelectButtonModule,
  CalendarModule,
  GalleriaModule,
  TagModule,
  InputNumberModule,
  ProgressBarModule,
  MessagesModule,
  FileUploadModule,
  InplaceModule,
  SliderModule,
  SplitButtonModule,
  PanelModule,
  PaginatorModule,
  KeyFilterModule,
  ChipsModule,
  ToastModule,
  InputOtpModule,
  ImageModule,
  OverlayPanelModule,
  FloatLabelModule,
  DragDropModule,
];

//#region Exports All Module
export * from 'primeng/message';
export * from 'primeng/timeline';
export * from 'primeng/messages';
export * from 'primeng/table';
export * from 'primeng/inputtext';
export * from 'primeng/dropdown';
export * from 'primeng/button';
export * from 'primeng/dialog';
export * from 'primeng/multiselect';
export * from 'primeng/accordion';
export * from 'primeng/treetable';
export * from 'primeng/checkbox';
export * from 'primeng/tooltip';
export * from 'primeng/confirmdialog';
export * from 'primeng/autocomplete';
export * from 'primeng/card';
export * from 'primeng/scrollpanel';
export * from 'primeng/progressspinner';
export * from 'primeng/steps';
export * from 'primeng/password';
export * from 'primeng/divider';
export * from 'primeng/sidebar';
export * from 'primeng/inputswitch';
export * from 'primeng/menu';
export * from 'primeng/inputtextarea';
export * from 'primeng/tabview';
export * from 'primeng/selectbutton';
export * from 'primeng/calendar';
export * from 'primeng/galleria';
export * from 'primeng/avatar';
export * from 'primeng/avatargroup';
export * from 'primeng/badge';
export * from 'primeng/tag';
export * from 'primeng/inputnumber';
export * from 'primeng/chart';
export * from 'primeng/progressbar';
export * from 'primeng/chip';
export * from 'primeng/radiobutton';
export * from 'primeng/fileupload';
export * from 'primeng/inplace';
export * from 'primeng/slider';
export * from 'primeng/splitbutton';
export * from 'primeng/panel';
export * from 'primeng/paginator';
export * from 'primeng/menubar';
export *  from 'primeng/keyfilter';
export * from 'primeng/editor';
export * from 'primeng/inputotp';
export * from 'primeng/inputgroup';
export * from 'primeng/inputgroupaddon';
export * from 'primeng/speeddial';
export * from 'primeng/image';
export * from 'primeng/skeleton';
export *  from 'primeng/overlaypanel';
//#endregion Exports All Module
